import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import Header from 'containers/SignupPages/Header';
import messages from 'containers/SignupPages/AuthByContratSuccess/messages';
import { translate } from 'helpers/intl';
import { createStructuredSelector } from 'reselect';
import {
  getKey1Selector,
  getKey2Selector,
  getKey3Selector,
  getTypeContractSelector,
} from 'store/contract/selectors';
import { connect } from 'react-redux';
import ContractInfo from './ContractInfo';
import ActionsButtons from '../ActionsButtons';
import { AUTH_BY_CONTRACT, ID_MEMO } from '../constants';

export interface AuthByContractEpargnSuccessType {
  intl: IntlShape;
  setSignupStep: Function;
  typeAssurance: string;
  key1: string;
  key2: string;
  key3: string;
}
const AuthByContractEpargnSuccess = (
  props: AuthByContractEpargnSuccessType,
) => {
  return (
    <React.Fragment>
      <Header
        title={translate({ ...messages.title }, props)}
        subTitle={translate({ ...messages.subTitle }, props)}
      />
      <ContractInfo
        typeAssurance={props.typeAssurance}
        key1={props.key1}
        key2={props.key2}
        key3={props.key3}
      />
      <ActionsButtons
        previousLabel={translate({ ...messages.precedent }, props)}
        nextLabel={translate({ ...messages.suivant }, props)}
        onClickNext={() => {
          props.setSignupStep(ID_MEMO);
        }}
        onClickPrevious={() => {
          props.setSignupStep(AUTH_BY_CONTRACT);
        }}
      />
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector({
  typeAssurance: getTypeContractSelector,
  key1: getKey1Selector,
  key2: getKey2Selector,
  key3: getKey3Selector,
});

export default connect(mapStateToProps)(
  injectIntl(AuthByContractEpargnSuccess),
);
